import React, { FunctionComponent } from 'react';
import styles from './Sidebar.module.scss';
import { Facebook, Linkedin, Twitter } from 'assets/icons';
import { getArticleAuthor } from 'utils';
import { WPSimpleArticle } from 'types/articles';
import { Icon, Image, Typography, Card } from 'components/elements';
import { WPAcfBlog } from 'types/acf';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';
import DOMPurify from 'dompurify';

interface OwnProps {
  data: WPSimpleArticle<WPAcfBlog>;
}

type SidebarProps = JSX.IntrinsicElements['div'] & OwnProps;

const Sidebar: FunctionComponent<SidebarProps> = props => {
  const { formatMessage } = useIntl();
  const { data: article } = props;
  const { title, _embedded } = article;
  const authors = getArticleAuthor(_embedded);
  const { name, description, simple_local_avatar, avatar_urls } = authors?.[0];
  const { full } = simple_local_avatar || {};

  return (
    <Card>
      {/* TODO: Responsive check */}
      <Image sizes="(max-width: 767px) 100vw, (min-width: 768px) 33.3333vw" src={full || avatar_urls['96']} />
      <div className={styles.authorBlock}>
        <Typography className={styles.authorName} mobile="new_neue_20_h2" tablet="new_neue_20_h2" desktop="new_neue_20_h2" as="h4">
          {name}
        </Typography>
        {description && (
          <Typography
            className={styles.authorDesc}
            mobile="new_ibm_regular_16"
            tablet="new_ibm_regular_16"
            desktop="new_ibm_regular_16"
            as="div"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
          />
        )}
        <Typography mobile="new_ibm_regular_16" tablet="new_ibm_regular_16" desktop="new_ibm_regular_16" as="span">
          {formatMessage(messages.share_this)}
        </Typography>
        <ul className={styles.links}>
          <li className={styles.link}>
            <FacebookShareButton url={window.location.href} quote={title.rendered}>
              <Icon size={36} icon={Facebook} />
            </FacebookShareButton>
          </li>
          <li className={styles.link}>
            <TwitterShareButton url={window.location.href} title={title.rendered}>
              <Icon size={36} icon={Twitter} />
            </TwitterShareButton>
          </li>
          <li className={styles.link}>
            <LinkedinShareButton url={window.location.href} title={title.rendered}>
              <Icon size={36} icon={Linkedin} />
            </LinkedinShareButton>
          </li>
        </ul>
      </div>
    </Card>
  );
};

export default Sidebar;
